import axios from "axios";
import { documentSearchUrl, documentUrl } from "../../Config/Url";
import { documentTypes } from "../../Config/DocumentTypes";

const { internalOutput } = documentTypes;

export const internalOutputService = {
  documentSearch,
  documentDelete,
  documentCreate,
  documentLock,
  getDocumentById,
  documentUpdate,
  documentDetails,
  documentCancel,
};

async function documentSearch(
  tenantId,
  searchText,
  pageIndex,
  pageSize,
  sortName,
  isAsc,
  storeId,
  dateFrom,
  dateTo
) {
  return axios
    .put(documentSearchUrl, {
      tenantId,
      searchText,
      pageIndex,
      pageSize,
      sortName,
      isAsc,
      documentTypeId: internalOutput,
      storeId,
      dateFrom,
      dateTo,
    })
    .then((res) => res)
    .catch((err) => err.response);
}

async function documentDelete(documentGuid) {
  return axios
    .delete(`${documentUrl}/${documentGuid}`)
    .then((res) => res)
    .catch((err) => err.response);
}

async function documentCreate(date, storeId, note, products) {
  let items = products.map((item) => ({
    documentTypeId: internalOutput,
    productGuid: item.productGuid,
    quantityOut: Number(item.quantity),
    priceOut: item.price,
  }));

  return axios
    .post(documentUrl, {
      documentTypeId: internalOutput,
      storeId,
      date,
      note,
      items,
    })
    .then((res) => res)
    .catch((err) => err.response);
}

async function documentUpdate(documentGuid, date, storeId, note, products) {
  let items = products.map((item) => ({
    documentDetailGuid: item.documentDetailGuid,
    documentTypeId: internalOutput,
    productGuid: item.productGuid,
    quantityOut: Number(item.quantityOut),
    priceOut: item.priceOut,
    isActive: Boolean(item.isActive),
  }));

  return axios
    .put(`${documentUrl}/${documentGuid}`, {
      documentGuid,
      documentTypeId: internalOutput,
      storeId,
      date,
      note,
      items,
    })
    .then((res) => res)
    .catch((err) => err.response);
}

async function documentLock(documentGuid) {
  return axios
    .patch(`${documentUrl}/${documentGuid}/lock`)
    .then((res) => res)
    .catch((err) => err.response);
}

async function getDocumentById(documentGuid) {
  return axios
    .get(`${documentUrl}/${documentGuid}`)
    .then((res) => res)
    .catch((err) => err.response);
}

async function documentDetails(documentGuid) {
  return axios
    .get(`${documentUrl}/${documentGuid}/details`)
    .then((res) => res)
    .catch((err) => err.response);
}

async function documentCancel(documentGuid) {
  return axios
    .patch(`${documentUrl}/${documentGuid}/storno`)
    .then((res) => res)
    .catch((err) => err.response);
}
